import { render, staticRenderFns } from "./CustomInputFile.vue?vue&type=template&id=18b12c38&lang=pug&"
import script from "./CustomInputFile.vue?vue&type=script&lang=js&"
export * from "./CustomInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
